import React, { useEffect, useState, useContext } from 'react';
import {
  Grid,
  Table,
  Label,
  Header,
  Menu,
  Icon,
  Form,
  Button,
  Checkbox,
  Segment,
} from 'semantic-ui-react';
import {
  getRoles,
  getRoleTasks,
  getTasks,
  setRoleTasks,
  createRole,
  updateRole,
} from '../../../actions';
import { Context } from '../../../defaults';
import styles from './index.module.css';

const Roles = () => {
  const { setLoading } = useContext(Context);
  const [roles, setRoles] = useState([]);
  const [tasks, setTasks] = useState([]);

  const [selectedRole, setSelectedRole] = useState({});
  const [newRole, setNewRole] = useState(undefined);

  const selectRole = (role) => {
    setLoading(true);
    setNewRole(undefined);
    setSelectedRole(role);
    getRoleTasks(role.id)
      .then((res) => res.json())
      .then((res) => {
        setTasks(tasks.map((el) => ({ ...el, checked: res.some((rt) => rt.id === el.id) })));
        setLoading(false);
      });
  };

  const saveNewRole = () => {
    setLoading(true);
    createRole({ Name: newRole.name, Value: newRole.value })
      .then((res) => res.json())
      .then((res) => {
        setSelectedRole(res);
        setRoles([...roles, res]);
        setNewRole(undefined);
        setLoading(false);
      });
  };

  const saveRoleChanges = () => {
    setLoading(true);
    const { id, name, value } = selectedRole;
    updateRole({ Id: id, Name: name, Value: value })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        setRoles(roles.map((el) => (el.id === id ? res : el)));
      });
  };

  const changeRole = (e, { name, value }) => {
    setSelectedRole({ ...selectedRole, [name]: value });
  };

  const changeNewRole = (e, { name, value }) => {
    setNewRole({ ...newRole, [name]: value });
  };

  const createNewRole = () => {
    setSelectedRole({});
    setNewRole({});
  };

  const bindTaskToRole = (taskId) => {
    setLoading(true);
    setRoleTasks({ TaskId: taskId, RoleId: selectedRole.id }).then(() => {
      setTasks(
        tasks.map((el) => {
          if (el.id === taskId) return { ...el, checked: !el.checked };
          return el;
        }),
      );
      setLoading(false);
    });
  };

  useEffect(() => {
    getRoles()
      .then((res) => res.json())
      .then((res) => {
        setRoles(res);
      });
    getTasks()
      .then((res) => res.json())
      .then((res) => {
        setTasks(res);
      });
  }, []);

  return (
    <div>
      <Header as="h2" attached="top">
        Привязать задачи к ролям
      </Header>
      <Segment attached>
        <Grid>
          <Grid.Column width={4}>
            <Menu fluid vertical pointing>
              {roles &&
                roles.map((el) => {
                  return (
                    <Menu.Item
                      name={`${el.name}`}
                      key={`role${el.id}`}
                      active={selectedRole.id === el.id}
                      onClick={() => selectRole(el)}
                    />
                  );
                })}
            </Menu>
            <Button content="Добавить роль" fluid onClick={createNewRole} />
          </Grid.Column>

          <Grid.Column stretched width={12}>
            {selectedRole.id && (
              <Header as="h3" attached="top">
                Роль - "{selectedRole.name}"
              </Header>
            )}
            {newRole && (
              <Header as="h3" attached="top">
                Создание роли
              </Header>
            )}
            <Segment attached>
              {selectedRole.id && (
                <div>
                  <Form>
                    <Form.Group widths="equal">
                      <Form.Input
                        name="value"
                        onChange={changeRole}
                        value={selectedRole.value}
                        label={'Название'}
                      />
                      <Form.Input
                        name="name"
                        onChange={changeRole}
                        value={selectedRole.name}
                        label={'Описание'}
                      />
                      <Form.Button
                        style={{ marginTop: 23 }}
                        content="Сохранить изменения в роли"
                        onClick={saveRoleChanges}
                        basic
                        color="green"
                      />
                    </Form.Group>
                  </Form>
                  <Header as="h4" attached="top">
                    Связанные задачи
                  </Header>
                  <Segment attached>
                    {tasks &&
                      tasks.map((el) => {
                        return (
                          <Checkbox
                            className={styles.checkBox}
                            key={`roletasks${selectedRole.id}-${el.id}`}
                            label={{ children: el.rus }}
                            onChange={() => bindTaskToRole(el.id)}
                            checked={el.checked}
                          />
                        );
                      })}
                  </Segment>
                </div>
              )}
              {newRole && (
                <div>
                  <Form>
                    <Form.Group widths="equal">
                      <Form.Input
                        name="value"
                        onChange={changeNewRole}
                        value={newRole.value}
                        label={'Название'}
                      />
                      <Form.Input
                        name="name"
                        onChange={changeNewRole}
                        value={newRole.name}
                        label={'Описание'}
                      />
                      <Form.Button
                        style={{ marginTop: 23 }}
                        content="Добавить роль"
                        onClick={saveNewRole}
                        basic
                        color="green"
                      />
                    </Form.Group>
                  </Form>
                </div>
              )}
            </Segment>
          </Grid.Column>
        </Grid>
      </Segment>
    </div>
  );
};

export default Roles;
